import CurrentBuildsPage from './current-builds.page.vue'

let routes = [
  {
    path: '/current-builds',
    name: 'current-builds',
    component: CurrentBuildsPage
  },
]

export default routes

